
import { defineComponent, PropType } from 'vue';
import DriveDesktopAllFiles from '@/modules/drive/components/desktop/cases/DriveDesktopAllFiles.vue';
import { useDriveStore } from '@/modules/drive/store/driveStore';
import { useMainStore } from '@/store/mainStore';
import NotificationService from '@/services/NotificationService';
import { ICaseFilesManage, ITemporaryFile } from '@/types/interfaces';

export default defineComponent({
  props: {
    customControl: { type: Boolean, default: false },
    temporaryFiles: { type: Array as PropType<ITemporaryFile[]> },
  },
  emits: ['close', 'addSelectedFiles'],
  components: {
    DriveDesktopAllFiles,
  },
  setup(props, { emit }) {
    const driveStore = useDriveStore();
    const mainStore = useMainStore();

    function fileUpdate() {
      if (props.customControl) {
        emit('addSelectedFiles', { selected: driveStore.files.filter((photo) => photo.selected), deselected: driveStore.files.filter((photo) => !photo.selected) });
        return;
      }

      const promises: Promise<any>[] = [];
      const addFilePayload = {
        id: driveStore.currentCase.id!,
        fileIds: [],
      } as ICaseFilesManage;
      const removeFilePayload = {
        id: driveStore.currentCase.id!,
        fileIds: [],
      } as ICaseFilesManage;

      addFilePayload.fileIds = driveStore.files
        .filter((photo) => photo.selected)
        .filter((photo) => !driveStore.currentCase.files.find((caseItem) => caseItem.contentId === photo.contentId))
        .map((photo) => photo.id);

      removeFilePayload.fileIds = driveStore.files
        .filter((photo) => !photo.selected)
        .filter((photo) => driveStore.currentCase.files.find((caseItem) => caseItem.contentId === photo.contentId))
        .map((photo) => driveStore.currentCase.files.find((caseItem) => caseItem.contentId === photo.contentId)!.id);

      if (addFilePayload.fileIds.length) {
        promises.push(driveStore.addFilesToCase(addFilePayload));
      }
      if (removeFilePayload.fileIds.length) {
        promises.push(driveStore.removeFilesFromCase(removeFilePayload));
      }

      if (promises.length) {
        Promise.all(promises)
          .then((responses) => {
            if (responses.every((response) => response.success)) {
              driveStore.currentCase.updated = Date.now();
              // NotificationService.notifySuccess();
            }
          });
      }
      emit('close');
    }

    return {
      driveStore,
      fileUpdate,
      mainStore,
    };
  },
});
